import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { ArrowUp, Rocket } from 'lucide-react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const toggleVisibility = () => {
      const scrolled = document.documentElement.scrollTop;
      const maxHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const progress = (scrolled / maxHeight) * 100;
      
      setScrollProgress(progress);
      setIsVisible(scrolled > 300);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className={`fixed bottom-8 right-8 z-50 transition-all duration-500 ${
      isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
    }`}>
      <Button
        onClick={scrollToTop}
        className="relative w-14 h-14 rounded-full bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-700 hover:to-blue-700 text-white shadow-lg hover:shadow-2xl hover:shadow-cyan-500/30 transition-all duration-300 transform hover:scale-110 border-0 overflow-hidden group"
      >
        {/* Animated background ring */}
        <div className="absolute inset-0 rounded-full border-2 border-white/30 animate-ping opacity-0 group-hover:opacity-100"></div>
        
        {/* Progress circle */}
        <svg className="absolute inset-0 w-full h-full transform -rotate-90" viewBox="0 0 56 56">
          <circle
            cx="28"
            cy="28"
            r="26"
            stroke="rgba(255,255,255,0.2)"
            strokeWidth="2"
            fill="none"
          />
          <circle
            cx="28"
            cy="28"
            r="26"
            stroke="rgba(255,255,255,0.8)"
            strokeWidth="2"
            fill="none"
            strokeDasharray={163.36} // 2 * π * r where r = 26
            strokeDashoffset={163.36 - (163.36 * scrollProgress) / 100}
            strokeLinecap="round"
            className="transition-all duration-300"
          />
        </svg>
        
        {/* Icon with animation */}
        <div className="relative z-10 flex items-center justify-center">
          <ArrowUp 
            size={20} 
            className="transform group-hover:scale-110 group-hover:-translate-y-1 transition-all duration-300" 
          />
        </div>
        
        {/* Hover effect shimmer */}
        <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-full"></div>
      </Button>
      
      {/* Rocket boost effect on hover */}
      <div className="absolute -top-2 -right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <Rocket size={16} className="text-cyan-400 animate-bounce" />
      </div>
    </div>
  );
};

export default ScrollToTop;